var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15184_3962)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3747,
    cy: 16.2638,
    rx: 6.04343,
    ry: 17.9321,
    transform: "rotate(45 16.3747 16.2638)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3748,
    cy: 16.2633,
    rx: 6.04343,
    ry: 17.9321,
    transform: "rotate(135 16.3748 16.2633)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15184_3962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7032,
    height: 31.7032,
    fill: "white",
    transform: "translate(0.609375 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape4.2552d28cfe52867ddeec49810963ccf9.svg";
export { ForwardRef as ReactComponent };